"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedCountryMapPage = exports.DefaultCountryMapPage = void 0;
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const spa_core_1 = require("@episerver/spa-core");
const PageTop_1 = __importDefault(require("../Shared/PageTop"));
const Glossary_1 = __importDefault(require("../Shared/Glossary"));
const react_redux_1 = require("react-redux");
const foundation_settings_1 = require("@episerver/foundation-settings");
const GlossaryService_1 = __importDefault(require("app/Components/Common/GlossaryService"));
const date_utils_1 = require("app/utils/date.utils");
const react_bootstrap_1 = require("react-bootstrap");
const react_svg_1 = require("react-svg");
const Button_1 = __importStar(require("app/Components/Common/Button"));
const TabFunctions_1 = require("app/Components/Common/TabFunctions");
const LoadingSpinner_1 = __importDefault(require("app/Components/Shared/LoadingSpinner"));
require("./CountryMapPage.scss");
const Shareticker_1 = __importDefault(require("app/Components/Common/Shareticker/Shareticker"));
const DefaultCountryMapPage = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    const ctx = (0, spa_core_1.useEpiserver)();
    const settingsService = (0, foundation_settings_1.useSettings)();
    const [layoutSettings, setLayoutSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LayoutSettings'));
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LabelSettings'));
    const language = props.currentLanguage;
    const defaultTab = ((_a = props.data.defaultTab) === null || _a === void 0 ? void 0 : _a.value.toString()) || '1';
    const tabContent = [];
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(defaultTab);
    const [eventsSet, setEventsSet] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const map = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        if (language !== undefined && ((_a = layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.language) === null || _a === void 0 ? void 0 : _a.name) !== language) {
            settingsService.getContainer('LayoutSettings').then(x => setLayoutSettings(x));
            settingsService.getContainer('LabelSettings').then(x => setLabelSettings(x));
        }
    }, [language]);
    const headingAreaMaxWidth = props.data.mainBodyWidth.value;
    let title = ((_c = (_b = props.data) === null || _b === void 0 ? void 0 : _b.metaTitle) === null || _c === void 0 ? void 0 : _c.value) || (typeof ((_d = props.data) === null || _d === void 0 ? void 0 : _d.name) === 'string' ? props.data.name : (_f = (_e = props.data) === null || _e === void 0 ? void 0 : _e.name) === null || _f === void 0 ? void 0 : _f.value);
    let updatedDate = ((_g = props.data.overridedUpdateDate) === null || _g === void 0 ? void 0 : _g.value) ?
        (_h = props.data.overridedUpdateDate) === null || _h === void 0 ? void 0 : _h.value : (_j = props.data) === null || _j === void 0 ? void 0 : _j.changed;
    const createTab = (contentArea, propertyName, name, eventKey, tabSearchName) => {
        return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: eventKey, key: propertyName, title: name, tabIndex: -1, tabAttrs: { 'data-update-search-params': tabSearchName } },
            react_1.default.createElement("div", { className: 'd-none d-print-block print-heading', "aria-hidden": true }, name),
            react_1.default.createElement(spa_core_1.Components.ContentArea, { data: contentArea, propertyName: propertyName, noWrap: true }));
    };
    const onTabSelect = (eventKey, event) => {
        setSelectedTab(eventKey);
        (0, TabFunctions_1.toggleTabs)('tabnav', setIsOpen);
        /* If we need to set focus to opened tab... here is the code
        try {
            (document.querySelector('#' + (event.target as HTMLElement).getAttribute('aria-controls')) as HTMLElement).focus()
        } catch { }*/
    };
    const getTabName = (tab) => {
        var _a, _b, _c, _d, _e;
        switch (tab || selectedTab) {
            case '1':
                return (_a = props.data.swedenName) === null || _a === void 0 ? void 0 : _a.value;
            case '2':
                return (_b = props.data.denmarkName) === null || _b === void 0 ? void 0 : _b.value;
            case '3':
                return (_c = props.data.norwayName) === null || _c === void 0 ? void 0 : _c.value;
            case '4':
                return (_d = props.data.finlandName) === null || _d === void 0 ? void 0 : _d.value;
            case '5':
                return (_e = props.data.greatBritainName) === null || _e === void 0 ? void 0 : _e.value;
            default:
                return '';
        }
    };
    const getTabId = (tab) => {
        switch (tab) {
            case 'Sweden':
                return '1';
            case 'Denmark':
                return '2';
            case 'Norway':
                return '3';
            case 'Finland':
                return '4';
            case 'UnitedKingdom':
                return '5';
            default:
                return '';
        }
    };
    if ((_k = props.data.swedenName) === null || _k === void 0 ? void 0 : _k.value)
        tabContent.push(createTab(props.data.swedenContent, 'swedenContent', props.data.swedenName.value, '1', 'Sweden'));
    if ((_l = props.data.denmarkName) === null || _l === void 0 ? void 0 : _l.value)
        tabContent.push(createTab(props.data.denmarkContent, 'denmarkContent', props.data.denmarkName.value, '2', 'Denmark'));
    if ((_m = props.data.norwayName) === null || _m === void 0 ? void 0 : _m.value)
        tabContent.push(createTab(props.data.norwayContent, 'norwayContent', props.data.norwayName.value, '3', 'Norway'));
    if ((_o = props.data.finlandName) === null || _o === void 0 ? void 0 : _o.value)
        tabContent.push(createTab(props.data.finlandContent, 'finlandContent', props.data.finlandName.value, '4', 'Finland'));
    if ((_p = props.data.greatBritainName) === null || _p === void 0 ? void 0 : _p.value)
        tabContent.push(createTab(props.data.greatBritainContent, 'greatBritainContent', props.data.greatBritainName.value, '5', 'UnitedKingdom'));
    const setHover = (el, over) => {
        const element = el.closest('[data-tab]');
        if (element) {
            const datatab = element.getAttribute('data-tab');
            const elements = document.querySelectorAll(`[data-tab="${datatab}"]`);
            elements.forEach((datael) => over ? datael.classList.add('hover') : datael.classList.remove('hover'));
        }
    };
    const selectFromMap = (el) => {
        const element = el.closest('[data-tab]');
        if (element) {
            const datatab = element.getAttribute('data-tab');
            setSelectedTab(datatab);
            const name = document.getElementById(`countrytabs-tab-${datatab}`).getAttribute('data-update-search-params');
            map.current.setAttribute('data-label', name);
            /* If we need to set focus to opened tab... here is the code
            try {
                (document.querySelector('#' + (document.getElementById(`countrytabs-tab-${datatab}`) as HTMLElement).getAttribute('aria-controls')) as HTMLElement).focus()
            } catch { }*/
        }
    };
    const setEvents = () => {
        if (!eventsSet) {
            const g = document.querySelectorAll('g');
            g.forEach((el) => {
                el.addEventListener('mouseover', () => {
                    setHover(el, true);
                });
                el.addEventListener('mouseleave', () => {
                    setHover(el, false);
                });
                el.addEventListener('click', () => {
                    selectFromMap(el);
                });
            });
            setEventsSet(true);
        }
    };
    const linkKeyDown = (e) => {
        const event = e;
        if (event.code === 'ArrowDown' || event.code === 'ArrowUp')
            e.stopPropagation();
    };
    (0, react_1.useEffect)(() => {
        if (!eventsSet && !ctx.isInEditMode())
            document.querySelector('.bg-map').addEventListener('mouseover', setEvents);
        const searchParam = new URLSearchParams(location.search).get('content');
        if (searchParam) {
            const tabid = getTabId(decodeURI(searchParam));
            if (tabid !== '')
                setSelectedTab(tabid);
        }
        document.querySelectorAll('.nav-link').forEach(link => {
            link.addEventListener('keydown', (e) => linkKeyDown(e));
        });
        return () => {
            const g = document.querySelectorAll('g');
            g.forEach((el) => {
                el.removeEventListener('mouseover', () => {
                    setHover(el, true);
                });
                el.removeEventListener('mouseleave', () => {
                    setHover(el, false);
                });
                el.removeEventListener('click', () => {
                    selectFromMap(el);
                });
            });
            document.querySelectorAll('.nav-link').forEach(link => {
                link.removeEventListener('keydown', (e) => linkKeyDown(e));
            });
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const tabnav = document.querySelector(`.nav-tabs`);
        tabnav.setAttribute('id', 'tabnav');
        if (!ctx.isInEditMode() && document.activeElement.id !== 'contentRow')
            document.querySelector('#heading-section').focus({ preventScroll: true });
    }, [props.contentLink.id]);
    if (!layoutSettings || !labelSettings)
        return react_1.default.createElement(LoadingSpinner_1.default, null);
    const langtags = [];
    ((_q = props.data.existingLanguages) === null || _q === void 0 ? void 0 : _q.length) > 1 &&
        props.data.existingLanguages.forEach(l => {
            langtags.push(react_1.default.createElement("link", { href: l.link, hrefLang: l.name, rel: "alternate", key: l.name }));
        });
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("link", { rel: "canonical", href: ((_r = props.data.canonicalUrl) === null || _r === void 0 ? void 0 : _r.value) ? `${ctx.getEpiserverURL()}${props.data.canonicalUrl.value}` : props.data.url }),
            ((_s = props.data.keywords) === null || _s === void 0 ? void 0 : _s.value) &&
                react_1.default.createElement("meta", { name: "keywords", content: props.data.keywords.value }),
            react_1.default.createElement("meta", { name: "description", content: ((_u = (_t = props.data) === null || _t === void 0 ? void 0 : _t.pageDescription) === null || _u === void 0 ? void 0 : _u.value) || (((_v = layoutSettings.companyDesc) === null || _v === void 0 ? void 0 : _v.value) ? (_w = layoutSettings.companyDesc) === null || _w === void 0 ? void 0 : _w.value : layoutSettings.companyDesc) }),
            react_1.default.createElement("meta", { property: "og:url", content: window.location.href }),
            react_1.default.createElement("meta", { property: "og:type", content: ((_x = props.data.metaContentType) === null || _x === void 0 ? void 0 : _x.value) || 'website' }),
            react_1.default.createElement("meta", { property: "og:title", content: title }),
            react_1.default.createElement("meta", { property: "og:description", content: ((_z = (_y = props.data) === null || _y === void 0 ? void 0 : _y.pageDescription) === null || _z === void 0 ? void 0 : _z.value) || (((_0 = layoutSettings.companyDesc) === null || _0 === void 0 ? void 0 : _0.value) ? (_1 = layoutSettings.companyDesc) === null || _1 === void 0 ? void 0 : _1.value : layoutSettings.companyDesc) }),
            ((_3 = (_2 = layoutSettings.facebookShareImage) === null || _2 === void 0 ? void 0 : _2.value) === null || _3 === void 0 ? void 0 : _3.url) &&
                react_1.default.createElement("meta", { property: "og:image", content: layoutSettings.facebookShareImage.value.url }),
            ((_5 = (_4 = layoutSettings.twitterShareImage) === null || _4 === void 0 ? void 0 : _4.value) === null || _5 === void 0 ? void 0 : _5.url) &&
                react_1.default.createElement("meta", { property: "twitter:image", content: layoutSettings.twitterShareImage.value.url }),
            react_1.default.createElement("meta", { name: "twitter:card", content: "summary" }),
            ((_6 = props.data.existingLanguages) === null || _6 === void 0 ? void 0 : _6.length) > 1 &&
                react_1.default.createElement("link", { href: props.data.url, hrefLang: "x-default", rel: "alternate" }),
            ((_7 = props.data.existingLanguages) === null || _7 === void 0 ? void 0 : _7.length) > 1 && langtags,
            ((_8 = props.data.jsonLdSchema) === null || _8 === void 0 ? void 0 : _8.value) && props.data.jsonLdSchema.value.trim() !== '' &&
                react_1.default.createElement("script", { type: "application/ld+json" }, props.data.jsonLdSchema.value)),
        react_1.default.createElement("main", { className: `page position-relative country-map-page map-${selectedTab}-selected`, role: 'main', tabIndex: -1 },
            react_1.default.createElement(PageTop_1.default, { layoutSettings: layoutSettings, showNews: props.data.showPageTopNews.value, breadCrumbsProps: props.data, fontWhite: props.data.pageTopFontColor.value, lang: language }),
            react_1.default.createElement(Glossary_1.default, { labelSettings: labelSettings, useGlossary: props.data.useGlossary.value, useShare: props.data.useShare.value }),
            react_1.default.createElement("div", { className: 'position-relative', ref: map },
                react_1.default.createElement(react_svg_1.ReactSVG, { src: '/spaview/app.html.spa/map_countries.svg?v=2', className: 'bg-map' }),
                props.data.showMobileShareTicker.value &&
                    react_1.default.createElement(Shareticker_1.default, { layoutSettings: layoutSettings, bgcolorClass: (_9 = props.data.shareTickerBackground) === null || _9 === void 0 ? void 0 : _9.value })),
            react_1.default.createElement("div", { className: 'heading-section row g-0' },
                react_1.default.createElement("div", { className: 'block layout r-narrow col-12' },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { id: 'heading-section', className: 'no-outline', tabIndex: -1 },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "mainBody", className: headingAreaMaxWidth }))))),
            react_1.default.createElement("section", { "aria-label": (_10 = props.data.tabSectionLabel) === null || _10 === void 0 ? void 0 : _10.value },
                react_1.default.createElement("div", { className: 'row g-0 overflow-hidden tabs-content' },
                    react_1.default.createElement("div", { className: 'block layout r-narrow col-12' },
                        react_1.default.createElement("div", { className: 'row g-0' },
                            react_1.default.createElement("div", { className: 'col-12 position-relative' },
                                react_1.default.createElement("div", { className: 'd-block d-sm-none tab-button' },
                                    react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.Outline, iconClass: 'icon-arrow-right-tail', onClick: () => (0, TabFunctions_1.toggleTabs)('tabnav', setIsOpen), title: getTabName(), ariacontrols: 'tabnav', ariaexpanded: isOpen })),
                                react_1.default.createElement(react_bootstrap_1.Tabs, { onSelect: onTabSelect, defaultActiveKey: defaultTab, activeKey: selectedTab, id: "countrytabs", className: "mb-9 mb-sm-10" }, tabContent)))),
                    react_1.default.createElement("div", { className: 'block layout r-narrow col-12' },
                        react_1.default.createElement("div", { className: 'row g-0 mt-9 mt-sm-10' },
                            react_1.default.createElement("div", { className: 'col-12 position-relative' },
                                react_1.default.createElement("div", { className: 'separator-light' })))))),
            react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.bottomContentArea, propertyName: "bottomContentArea" }),
            ((_11 = props.data.showPageDate) === null || _11 === void 0 ? void 0 : _11.value) &&
                react_1.default.createElement("div", { className: 'row g-0' },
                    react_1.default.createElement("div", { className: 'block layout col-12' },
                        react_1.default.createElement("div", { className: 'mb-6' },
                            react_1.default.createElement("div", { className: 'row' },
                                react_1.default.createElement("div", { className: 'col-12 text-gray-opacity-70' },
                                    react_1.default.createElement("p", null,
                                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: "updatedText" }),
                                        ' ' + (0, date_utils_1.getFormatedGeneralDate)(updatedDate, language, true)))))))),
        react_1.default.createElement(GlossaryService_1.default, { glossaryActive: props.glossaryOpen && props.data.useGlossary.value, settings: layoutSettings }));
};
exports.DefaultCountryMapPage = DefaultCountryMapPage;
exports.ConnectedCountryMapPage = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    const propsFromAppState = state.ApplicationStates || {};
    return Object.assign(Object.assign(Object.assign({}, ownProps), propsFromState), propsFromAppState);
})(exports.DefaultCountryMapPage);
const CountryMapPage = (props) => {
    const ctx = (0, spa_core_1.useEpiserver)();
    if (ctx.isServerSideRendering())
        return react_1.default.createElement(exports.DefaultCountryMapPage, Object.assign({}, props));
    return react_1.default.createElement(exports.ConnectedCountryMapPage, Object.assign({}, props));
};
exports.default = CountryMapPage;
